import Api from "@root/components/api";

export default class FieldSetMutation {
    async load() {
        let query = `query {
            currentUser {    
                fieldSets {
                    id, name,
                    fields {
                        name, type,
                        i18n, multi, cardTemplateId
                    }
                }
                cardTemplates {
                    id, name, cardCount
                    fieldSets {
                        id, name
                    }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (result.errors) {
            return;
        }        
        return result.data.currentUser;        
    }

    async save(cardTemplate) {
        let query = `mutation ($input: CardTemplateInput!) {
            saveCardTemplate(input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: cardTemplate.id,
                name: cardTemplate.name ?? "", 
                description: cardTemplate.description ?? "",
                fieldSets: cardTemplate.fieldSets.map(f => f.id),
            }
        }});
    } 

    async remove(cardTemplateId) {
        let query = `mutation ($cardTemplateId: String!) {
            removeCardTemplate(cardTemplateId: $cardTemplateId)
        }`;
        const response = await Api.postData('/g', { query: query, variables: {
            cardTemplateId: cardTemplateId,
        }});
        return response.data.removeCardTemplate;
    } 
}